import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import { H3, LayoutSingleColumn, NamedLink, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import SectionFooter from '../PageBuilder/SectionBuilder/SectionFooter';

import css from './PrivacyPolicyPage.module.css';
import contact from './contact.png';

// This "content-only" component can be used in modals etc.
export const PrivacyPolicyContent = props => {
  return (
    <div className={css.root}>
      <H3>
        PRIVACY POLICY / HOW WE USE COOKIES
      </H3>

      <p className={css.info}>
        <strong>HOUSESIT MATCH LIMITED</strong> (Company Registered Number: 07892745) (“We”) are committed to protecting and respecting your privacy. This Privacy policy (together with our{" "}
        <NamedLink name="TermsOfServicePage">
          Terms of Use
        </NamedLink>
        {" "}and any other documents referred to on it) sets out the basis on which any personal data we collect from you, or that you provide to us, will be processed by us. Please read the following carefully to understand our views and practices regarding your personal data and how we will treat it.
      </p>
      <br />
      <p className={css.info}>
        For the purpose of the Data Protection Act 1998 (the Act), the data controller is HOUSESIT MATCH LIMITED whose registered office is at 7 West Waye, High Wycombe, Buckinghamshire, HP13 5PT.
      </p>
      <br />
      <p className={css.info}>
        Our nominated representative for the purpose of the Act is Lamia Walker to whom any queries about the Privacy policy may be addressed.
      </p>

      <p className={css.subtitleSmall}>
        INFORMATION WE MAY COLLECT FROM YOU
      </p>
      <p className={css.info}>
        We may collect and process the following data about you:
      </p>
      <br />
      <p className={css.info}>
        Information that you provide by filling in forms on our site housesitmatch.com (our site). This includes information provided at the time of registering to use our site, subscribing to our service, posting material or requesting further services. We may also ask you for information when you report a problem with our site.
      </p>
      <br />
      <p className={css.info}>
        If you contact us, we may keep a record of that correspondence.
      </p>
      <br />
      <p className={css.info}>
        We may also ask you to complete surveys that we use for research purposes, although you do not have to respond to them.
      </p>
      <br />
      <p className={css.info}>
        Details of transactions you carry out through our site and of the fulfilment of your orders.
      </p>
      <br />
      <p className={css.info}>
        Details of your visits to our site including, but not limited to, traffic data, location data, weblogs and other communication data, whether this is required for our own billing purposes or otherwise and the resources that you access.
      </p>

      <p className={css.subtitleSmall}>
        HOUSESIT MATCH'S G.D.P.R. STATEMENT
      </p>
      <p className={css.info}>
        We are compliant with GDPR and EU regulations.
      </p>
      <br />
      <p className={css.info}>
        HouseSit Match has opted for third party cloud-based solutions, all with restricted access to client data by our employees. Our emails and website are also encrypted for extra safety. As a company, we hold very little personal details on our clients, we veil the identity of all our clients in the membership and only they reveal their identity to each other at a time they believe appropriate to make suitable arrangements for their Housesit.
      </p>
      <br />
      <p className={css.info}>
        For more information on how it affects you, both digitally and through traditional methods,{" "}
        <a href="https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/">
          please see this GDPR page
        </a>.
      </p>

      <p className={css.subtitleSmall}>
        IP ADDRESSES
      </p>
      <p className={css.info}>
        We may collect information about your computer, including where available your IP address, operating system and browser type, for system administration and to report aggregate information to our advertisers. This is statistical data about our users’ browsing actions and patterns, and does not identify any individual.
      </p>

      <p className={css.subtitleSmall}>
        COOKIES
      </p>
      <p className={css.info}>
        Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site. For detailed information on the cookies we use and the purposes for which we use them see our information about How we use cookies.
      </p>

      <p className={css.subtitleSmall}>
        WHERE WE STORE YOUR PERSONAL DATA
      </p>
      <p className={css.info}>
        The data that we collect from you may be transferred to, and stored at, a destination outside the European Economic Area (“EEA”). It may also be processed by staff operating outside the EEA who work for us or for one of our suppliers. Such staff maybe engaged in, among other things, the fulfilment of your order, the processing of your payment details and the provision of support services. By submitting your personal data, you agree to this transfer, storing or processing. We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this privacy policy.
      </p>
      <br />
      <p className={css.info}>
        All information you provide to us is stored on our secure servers. Any payment transactions will be encrypted using SSL technology. Where we have given you (or where you have chosen) a password which enables you to access certain parts of our site, you are responsible for keeping this password confidential. We ask you not to share a password with anyone in line with our Privacy policy.
      </p>
      <br />
      <p className={css.info}>
        Unfortunately, the transmission of information via the internet is not completely secure. Although we will do our best to protect your personal data, we cannot guarantee the security of your data transmitted to our site; any transmission is at your own risk. Once we have received your information, we will use strict procedures and security features to try to prevent unauthorised access.
      </p>

      <p className={css.subtitleSmall}>
        USES MADE OF THE INFORMATION
      </p>
      <p className={css.info}>
        We use information held about you in the following ways:
      </p>
      <br />
      <p className={css.info}>
        To ensure that content from our site is presented in the most effective manner for you and for your computer.
      </p>
      <br />
      <p className={css.info}>
        To provide you with information, products or services that you request from us or which we feel may interest you, where you have consented to be contacted for such purposes.
      </p>
      <br />
      <p className={css.info}>
        To carry out our obligations arising from any contracts entered into between you and us.
      </p>
      <br />
      <p className={css.info}>
        To allow you to participate in interactive features of our service, when you choose to do so.
      </p>
      <br />
      <p className={css.info}>
        To notify you about changes to our service.
      </p>
      <br />
      <p className={css.info}>
        We may also use your data, or permit selected third parties to use your data, to provide you with information about goods and services which may be of interest to you and we or they may contact you about these by post or telephone.
      </p>
      <br />
      <p className={css.info}>
        If you are an existing customer, we will only contact you by electronic means (e-mail or SMS) with information about goods and services similar to those which were the subject of a previous sale to you.
      </p>
      <br />
      <p className={css.info}>
        If you are a new customer, and where we permit selected third parties to use your data, we (or they) will contact you by electronic means only if you have consented to this.
      </p>
      <br />
      <p className={css.info}>
        If you do not want us to use your data in this way, or to pass your details on to third parties for marketing purposes, please tick the relevant box situated on the form on which we collect your data (the registration form).
      </p>
      <br />
      <p className={css.info}>
        We do not disclose information about identifiable individuals to our advertisers, but we may provide them with aggregate information about our users (for example, we may inform them that 500 men aged under 30 have clicked on their advertisement on any given day). We may also use such aggregate information to help advertisers reach the kind of audience they want to target (for example, women in SW1). We may make use of the personal data we have collected from you to enable us to comply with our advertisers’ wishes by displaying their advertisement to that target audience.
      </p>

      <p className={css.subtitleSmall}>
        DISCLOSURE OF YOUR INFORMATION
      </p>
      <p className={css.info}>
        We may disclose your personal information to any member of our group, which means our subsidiaries, our ultimate holding company and its subsidiaries, as defined in section 1159 of the UK Companies Act 2006.
      </p>
      <br />
      <p className={css.info}>
        We may disclose your personal information to third parties:
      </p>
      <br />
      <p className={css.info}>
        In the event that we sell or buy any business or assets, in which case we may disclose your personal data to the prospective seller or buyer of such business or assets.
      </p>
      <br />
      <p className={css.info}>
        If HOUSESIT MATCH LIMITED or substantially all of its assets are acquired by a third party, in which case personal data held by it about its customers will be one of the transferred assets.
      </p>
      <br />
      <p className={css.info}>
        If we are under a duty to disclose or share your personal data in order to comply with any legal obligation, or in order to enforce or apply our{" "}
        <NamedLink name="TermsOfServicePage">
          Terms of Use
        </NamedLink>
        , and other agreements; or to protect the rights, property, or safety of HOUSESIT MATCH LIMITED, our customers, or others. This includes exchanging information with other companies and organisations for the purposes of fraud protection and credit risk reduction.
      </p>


      <p className={css.subtitleSmall}>
        YOUR RIGHTS REGARDING OUR PRIVACY POLICY
      </p>
      <p className={css.info}>
        You have the right to ask us not to process your personal data for marketing purposes. We will usually inform you (before collecting your data) if we intend to use your data for such purposes or if we intend to disclose your information to any third party for such purposes. You can exercise your right to prevent such processing by checking certain boxes on the forms we use to collect your data.
      </p>
      <br />
      <p className={css.info}>
        You can also exercise the right at any time by contacting us at{" "}
        <a href="mailto: admin@housesitmatch.com">
          admin@housesitmatch.com
        </a>.
      </p>
      <br />
      <p className={css.info}>
        Our site may, from time to time, contain links to and from the websites of our partner networks, advertisers and affiliates. If you follow a link to any of these websites, please note that these websites have their own privacy policies and that we do not accept any responsibility or liability for these policies. Please check these policies before you submit any personal data to these websites.
      </p>

      <p className={css.subtitleSmall}>
        ACCESS TO INFORMATION
      </p>
      <p className={css.info}>
        The Act gives you the right to access information held about you. Your right of access can be exercised in accordance with the Act. Any access request may be subject to a fee of £10 GB to meet our costs in providing you with details of the information we hold about you. We will be happy to provide the information in line with our Privacy policy.
      </p>

      <p className={css.subtitleSmall}>
        CHANGES TO OUR PRIVACY POLICY
      </p>
      <p className={css.info}>
        Any changes we may make to our privacy policy in the future will be posted on this page and, where appropriate, notified to you by e-mail.
      </p>

      <p className={css.subtitleSmall}>
        CONTACT
      </p>
      <div className={css.row}>
        <a href="mailto: admin@housesitmatch.com">
          <img src={contact} className={css.contact} alt="contact" />
        </a>
        <p className={css.info}>
          Questions, comments and requests regarding this privacy policy are welcomed and should be addressed to{" "}
          <a href="mailto: admin@housesitmatch.com">
            admin@housesitmatch.com
          </a>.
        </p>
      </div>
    </div >
  );
};

// Presentational component for PrivacyPolicyPage
const PrivacyPolicyPage = props => {
  const config = useConfiguration();
  const intl = useIntl();

  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'PrivacyPolicyPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({ id: 'PrivacyPolicyPage.schemaDescription' }, { marketplaceName });

  return (
    <Page
      title={schemaTitle}
      description={schemaDescription}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<SectionFooter />}
        mainColumnClassName={css.mainColumnClassName}
      >
        <PrivacyPolicyContent />
      </LayoutSingleColumn>
    </Page>
  );
};

export default PrivacyPolicyPage;
